import api from "../index";
import {
  MessageResponse,
  PaginatedData,
  PaginatedDataRequest,
  User,
} from "@/types";
import { AuthCheckResponse } from "@/redux/api/Users/types";
import { UserFormRequest } from "@admin/redux/api/User/type";

const UsersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsers: builder.query<PaginatedData<User>, PaginatedDataRequest>({
      query: (data) => ({
        url: "/admin/user",
        method: "GET",
        params: data,
      }),
    }),
    getUserById: builder.query<User, string>({
      query: (id: string) => `/admin/user/${id}`,
    }),
    updateUserById: builder.mutation<User, UserFormRequest>({
      query: ({ id, data }) => ({
        url: `/admin/user/${id}`,
        method: "PUT",
        data,
      }),
    }),
    createUser: builder.mutation<User, UserFormRequest>({
      query: ({ data }) => ({
        url: `/admin/user`,
        method: "POST",
        data,
      }),
    }),
    deleteUserById: builder.mutation<MessageResponse, number>({
      query: (id) => ({
        url: `/admin/user/${id}`,
        method: "DELETE",
      }),
    }),
    getUserInfo: builder.query<User, void>({
      query: () => `/auth/user`,
    }),
    checkAuth: builder.query<AuthCheckResponse, void>({
      query: () => `/auth/check`,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAllUsersQuery,
  useGetUserByIdQuery,
  useUpdateUserByIdMutation,
  useCreateUserMutation,
  useDeleteUserByIdMutation,
  useGetUserInfoQuery,
  useCheckAuthQuery,
} = UsersApi;
export default UsersApi;
